module.exports = __webpack_public_path__ + "static/img/battle_report3.5ef80b9c.png";